import React, { Component } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Measure from 'react-measure';
import ReactGA from 'react-ga';

import Router from './components/Router';

import drinks from './data/drinks';

class App extends Component {
  constructor(props) {
    super(props);

    this.drinks = drinks;
    this.minAnswer = 0;
    this.maxAnswer = 999;

    let answers = {};

    // Initialise an object for user answers
    for (var drink of drinks) {
      answers[drink.name] = 0;
    }

    this.state = {
      currentView: 'form',
      answers: answers,
      contentHeight: -1,
      user: {
        gender: '',
        genderCustom: ''
      },
      smoothScrollToTop: false
    };

    // Init analytics
    ReactGA.initialize('UA-36583197-1');
  }

  goTo = viewName =>
    this.setState({
      currentView: viewName,
      smoothScrollToTop: true
    });

  resetToInitialState = () => {
    let answers = {};

    // Initialise an object for user answers
    for (var drink of drinks) {
      answers[drink.name] = 0;
    }

    this.setState({
      currentView: 'form',
      answers: answers,
      user: {
        gender: '',
        genderCustom: ''
      }
    });
  };

  handleUserUpdate = event => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      user: {
        ...this.state.user,
        [name]: value
      }
    });
  };

  decrementAnswer = name => {
    let oldAnswer = this.state.answers[name];
    let newAnswer = oldAnswer;

    if (Number.isInteger(oldAnswer) && oldAnswer > this.minAnswer) {
      newAnswer = parseInt(oldAnswer - 1);
    } else {
      newAnswer = 0;
    }

    this.setState({
      answers: Object.assign(this.state.answers, {
        [name]: newAnswer
      })
    });
  };

  incrementAnswer = name => {
    let oldAnswer = this.state.answers[name];
    let newAnswer = oldAnswer;

    if (Number.isInteger(oldAnswer) && oldAnswer < this.maxAnswer) {
      newAnswer = parseInt(oldAnswer + 1);
    } else {
      newAnswer = 1;
    }

    this.setState({
      answers: Object.assign(this.state.answers, {
        [name]: newAnswer
      })
    });
  };

  updateAnswer = event => {
    const regEx = /^[0-9]{1,3}$/;
    const target = event.target;
    const value = target.value;
    const name = target.name;
    let newAnswer = '';

    if (value === '') {
      newAnswer = '';
    } else if (regEx.test(value) && !isNaN(parseInt(value))) {
      newAnswer = parseInt(value);
    }

    if (value === '' || regEx.test(value)) {
      this.setState({
        answers: Object.assign(this.state.answers, {
          [name]: newAnswer
        })
      });
    }
  };

  render() {
    return (
      <div className="u-container u-mx-auto u-max-w-md md:u-p-4 u-bg-white u-bg-white md:u-border-solid u-border-2 u-border-orange">
        <div
          className={'u-relative u-transition u-transition-slow u-transition-min-height'}
          style={{ minHeight: this.state.contentHeight }}
        >
          <TransitionGroup>
            <CSSTransition key={this.state.currentView} timeout={500} classNames="fade">
              <Measure
                bounds
                onResize={contentRect => {
                  // Content height should only increase, not decrease
                  this.setState({
                    contentHeight: contentRect.bounds.height
                  });
                }}
              >
                {({ measureRef }) => (
                  <Router
                    answers={this.state.answers}
                    currentView={this.state.currentView}
                    decrementAnswer={this.decrementAnswer}
                    drinks={this.drinks}
                    goBack={this.goBack}
                    goTo={this.goTo}
                    handleAnswer={this.handleAnswer}
                    incrementAnswer={this.incrementAnswer}
                    handleUserUpdate={this.handleUserUpdate}
                    innerRef={measureRef}
                    maxAnswer={this.maxAnswer}
                    minAnswer={this.minAnswer}
                    updateAnswer={this.updateAnswer}
                    user={this.state.user}
                    smoothScrollToTop={this.state.smoothScrollToTop}
                    resetToInitialState={this.resetToInitialState}
                  />
                )}
              </Measure>
            </CSSTransition>
          </TransitionGroup>
        </div>
      </div>
    );
  }
}

export default App;
